import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import ShareIcon from '@mui/icons-material/Share';
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';

const GoogleIcons = ({show}) => {

  if (show) {
    return (
      <>
        <div className="flex flex-row w-full justify-between pl-4 pr-3 pt-5">
          <div><ArrowBackOutlinedIcon className='ml-[2px]' sx={{ fontSize: 28 }}/></div>
          <div className='flex flex-row gap-6'>
            <StarBorderRoundedIcon className='text-white -mt-[7px] mr-[3px]' sx={{ fontSize: 44 }}/>
            <ShareIcon className='mt-[1px] mr-[2px]' sx={{ fontSize: 28 }}/>
            <RestoreRoundedIcon className='mt-[1px] mr-[5px]' sx={{ fontSize: 28 }}/>
          </div>
        </div>
      </>
    )
  } 
}

export default GoogleIcons